import { stores } from '../translations';
import { useCurrentStore } from './useCurrentStore';
import { useDispatch } from 'react-redux';
import requests from '../redux/reducer/requests';
import { useUser } from '../redux/reducer/user';
import { canChangeCountry } from '../constants/country';

export const useCountryControls = () => {
  const { profile } = useUser();
  const currentStore = useCurrentStore();
  const dispatch = useDispatch();
  const isCountryChangeAllowed = canChangeCountry(profile);

  const availableMeCountries = [stores.ae, stores.sa, stores.qa];

  const changeCountry = (newStore) => {
    if (
      !newStore ||
      !availableMeCountries.includes(newStore) ||
      !isCountryChangeAllowed ||
      newStore === profile?.userCountry
    )
      return;

    dispatch(requests.thunks.setCountry(newStore));
  };

  return {
    currentStore: profile?.userCountry || currentStore,
    availableCountries: availableMeCountries,
    canChangeCountry: isCountryChangeAllowed,
    changeCountry,
  };
};
